// The maximum number of Group nodes to render in the group list initially
export var MAX_GROUP_NODES_WHEN_COLLAPSED = 5;
//# sourceMappingURL=constants.js.map